var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grade-chart",class:_vm.heightClass},[_c('bar-chart',{attrs:{"data":_vm.chartData(),"options":{
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      legend: { display: false },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    }}}),_vm._v(" "),_c('v-btn',{staticClass:"chart-to-png-btn",attrs:{"icon":""},on:{"click":function($event){return _vm.chartToPng()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("\n      "+_vm._s(_vm.mdiCamera)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }